<template>
  <div>
    <v-menu
      ref="menu"
      v-model="menu"
      class="date-picker"
      :close-on-click="true"
      :close-on-content-click="false"
      min-width="290px"
      offset-y
      transition="scale-transition"
    >
      <template #activator="{ attrs }">
        <div @click="menu = true">
          <div v-if="date && date[0] !== '' && date[1] !== ''" class="mf-date-range-picker-input-container">
            <mf-icon color="marca-0-l40" fill icon="event" />
            <span>{{ formatDate(date[0]) }}</span>
            <div class="separator" />
            <span>{{ formatDate(date[1]) }}</span>
          </div>
          <div v-else class="mf-date-range-picker-input-container">
            <mf-icon color="marca-0-l40" fill icon="event" />
            <span>Selecione uma data</span>
          </div>
        </div>
      </template>
      <v-date-picker
        v-model="date"
        data-cy="mf-range-picker"
        locale="pt-BR"
        :max="max"
        :min="min"
        range
        :picker-date.sync="pickerDate"
        :events="events"
        :event-color="eventColor"
        @change="change"
      />
    </v-menu>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
export default {
  name: 'MFRangePicker',
  components: {},
  props: {
    initialDate: {
      type: String,
      default: '',
    },
    finalDate: {
      type: String,
      default: '',
    },
    min: {
      type: String,
      default: '',
    },
    max: {
      type: String,
      default: '',
    },
    defaultPickerDate: {
      type: String,
      default: '',
    },
    eventColor: {
      type: String,
      default: '',
    },
    events: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    menu: false,
    date: [],
    isTyping: false,
    pickerDate: '2024-01',
  }),
  watch: {
    initialDate: {
      handler(value) {
        this.date[0] = value
        if (value) {
          this.pickerDate = value
        }
      },
      immediate: true,
    },
    finalDate: {
      handler(value) {
        this.date[1] = value
      },
      immediate: true,
    },
  },
  mounted() {
    this.pickerDate = this.defaultPickerDate
  },
  methods: {
    change(value) {
      this.date = value
      this.menu = false
      this.$emit('update:initialDate', value[0])
      this.$emit('update:finalDate', value[1])
      this.$emit('change', value)
    },
    formatDate(date) {
      return date ? DateTime.fromFormat(date.toString(), 'yyyy-MM-dd').toFormat('dd/MM/yyyy') : ''
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-text-field__details {
  margin: 0 !important;
  padding: 0 !important;
}

#date-picker-icon {
  height: 24px;
}
.v-text-field__details {
  padding-left: 0 !important;
}
.error-message {
  color: #e03210;
}
::v-deep input {
  pointer-events: none !important;
}
.mf-date-range-picker-input-container {
  cursor: pointer;
  max-width: 340px;
  padding-top: 5px;
  display: flex;
  align-items: center;
  gap: 4px;

  span {
    color: $marca-0-l10;
    font-size: 14px;
    margin: 0;
    font-weight: 400;
    line-height: 1;
  }

  .separator {
    background: $marca-0-l40;
    height: 1px;
    width: 8px;
  }
}
</style>
